
import EazyHeading from '@/components/EazyHeading.vue';
import router from '@/router';
import store from '@/store';

export default {
  name: 'Tutorials',

  components: {
    EazyHeading,
  },

  computed: {
    userRole(): void {
      return store.state.userRole;
    },
  },

  methods: {
    goToDashboardTutorial(): void {
      store.commit('setHomePageGuideToNotDone');
      router.push({ path: `/${this.userRole}-tasks` });
    },
  },
};
